class Header {

    stateClasses = {
        hide: "hide",
        background: "header__background",

    }
    constructor($el) {
        this.$el = $el;
        this.init();
        this.lastScrollTop = 0;
    }

    init = () => {
        $(window).on('scroll', this.handleScroll);
    }

    handleScroll = () => {
        const scrollTop = $(window).scrollTop();
        const scrollingDown = scrollTop > this.lastScrollTop;

            if (scrollingDown && scrollTop > 0) {
                this.$el.addClass(this.stateClasses.hide)
                this.$el.removeClass(this.stateClasses.background);
            }

            else if (scrollTop <= 0) {
                this.$el.removeClass(this.stateClasses.background)
            }
            else {
                this.$el.removeClass(this.stateClasses.hide);
                this.$el.addClass(this.stateClasses.background);

            }
        

        this.lastScrollTop = Math.max(scrollTop, 0);
    };
}

export default Header;